import PropTypes from 'prop-types';
import * as Popover from '@radix-ui/react-popover';
import { cn } from '../../../lib/utils';

AppPopover.propTypes = {
  trigger: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  side: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  align: PropTypes.oneOf(['start', 'center', 'end']),
}

export default function AppPopover({ trigger, children, side = 'bottom', align = 'start' }) {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>{trigger}</Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          className={cn(
            'bg-[var(--surface-card,#fff)]',
            'border border-[var(--border-subtle-2,#E2E8F0)]',
            'rounded-[var(--radius-md,8px)]',
            'shadow-[0_4px_16px_rgba(0,0,0,0.12)]',
            'z-[1050]',
            'animate-popover-in',
          )}
          side={side}
          align={align}
          sideOffset={4}
        >
          {children}
          <Popover.Arrow className="fill-[var(--border-subtle-2,#E2E8F0)]" />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
